import { CALL_API } from '../../middleware/api';
import * as ActionTypes from '../makeBet';
function fetchMakeBet(data) {
    var _a;
    return _a = {
            type: ActionTypes.MAKE_BET
        },
        _a[CALL_API] = {
            endpoint: '/bet/web/create',
            method: 'post',
            types: [
                ActionTypes.SUCCESS_MAKE_BET,
                ActionTypes.FAILURE_MAKE_BET
            ],
            credentials: true,
            data: data
        },
        _a;
}
export function makeBet(apiData, historyData) {
    return function (dispatch, getState) {
        var client = getState().application.get('client');
        apiData['sourceIp'] = client.ip;
        return dispatch(fetchMakeBet(apiData, historyData));
    };
}
function fetchMakeMultiSingleBet(data) {
    var _a;
    return _a = {
            type: ActionTypes.MAKE_MULTI_SINGLE_BET
        },
        _a[CALL_API] = {
            endpoint: '/bet/web/create-multi',
            method: 'post',
            types: [
                ActionTypes.SUCCESS_MAKE_MULTI_SINGLE_BET,
                ActionTypes.FAILURE_MAKE_MULTI_SINGLE_BET
            ],
            credentials: true,
            data: data
        },
        _a;
}
export function makeMultiSingleBet(apiData) {
    return function (dispatch, getState) {
        var basketBets = apiData.basketBets;
        var bets = getState().coupon.getIn(['couponStatus', 'bets']);
        var client = getState().application.get('client');
        apiData['sourceIp'] = client.ip;
        bets.map(function (bet, key) {
            var status = bet.get('status');
            if (status === 2) {
                var basketBetIndex = basketBets.findIndex(function (b) { return b.betNum === key; });
                basketBets.splice(basketBetIndex, 1);
            }
        });
        apiData['basketBets'] = basketBets;
        return dispatch(fetchMakeMultiSingleBet(apiData));
    };
}
function fetchMakeQuickBet(data) {
    var _a;
    return _a = {
            type: ActionTypes.MAKE_QUICKBET
        },
        _a[CALL_API] = {
            endpoint: '/bet/web/create',
            method: 'post',
            types: [
                ActionTypes.SUCCESS_MAKE_QUICKBET,
                ActionTypes.FAILURE_MAKE_QUICKBET
            ],
            credentials: true,
            data: data
        },
        _a;
}
export function makeQuickBet(apiData, historyData) {
    return function (dispatch, getState) {
        var client = getState().application.get('client');
        apiData['sourceIp'] = client.ip;
        return dispatch(fetchMakeQuickBet(apiData, historyData));
    };
}



// WEBPACK FOOTER //
// ./src/actions/creators/makeBet.js